module.exports = __webpack_public_path__ + "img/@logo_kdblife@3x.5cef220c.png";